import {colors} from "@buildwithflux/core";
import {Color} from "three";

export const ColorSilkTop = new Color(colors.canvas.pcb.layout.stackupLayerColors.topOverlay).convertLinearToSRGB();

export const ColorSilkBottom = new Color(
    colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
).convertLinearToSRGB();
